import reduceOpacity from '../utils/reduce-opacity';
import isDark from '../verifiers/is-dark';

const primaryButtonDisabled = (params) => {
  const { targetColor, backgroundColor, surfaceColor } = params;
  const fallback = {
    rule: 'primaryButton.background.disabled',
    params,
  };
  if (isDark(backgroundColor)) {
    return reduceOpacity({
      targetColor,
      backgroundColor,
      surfaceColor,
      opacity: targetColor.alpha,
      condition: (ratio) => ratio <= 1.2,
      fallback,
    });
  }
  return reduceOpacity({
    targetColor,
    backgroundColor,
    surfaceColor,
    opacity: targetColor.alpha,
    condition: (ratio) => ratio <= 1.04,
    fallback,
  });
};

export default primaryButtonDisabled;
